import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from './icons/InfoIcon';
import { WarnIcon } from './icons/WarnIcon';
import { CheckIcon } from './icons/CheckIcon';
import { RobotOutlined } from '@ant-design/icons';
import { SectionIcon } from './SectionIcon';

export const AiOverview = ({ ai }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section id="ai" className="card" aria-labelledby="ai-title">
            <div className="sechead">
                <h2 id="ai-title" className="h2">
                    <SectionIcon icon={RobotOutlined} />
                    {t('ai.title')}
                </h2>
                {ai.ok && (
                    <span className="aipill">
                        {ai.basis === 'inspection' ? t('ai.basedOnInspection') : t('ai.pill')}
                    </span>
                )}
            </div>
            {ai.ok && (
                <div className="ai-text">
                    {ai.paragraphs.map((paragraph, paragraphIndex) => (
                        <p key={paragraphIndex}>{paragraph}</p>
                    ))}
                </div>
            )}
            {ai.noFlags && (
                <div className="okline">
                    <CheckIcon size={22} />
                    <span>{t('ai.noFlags')}</span>
                </div>
            )}
            {ai.flags.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    <h3 className="h3">
                        {t('ai.redFlags')}{' '}
                        <span style={{ fontWeight: 400, color: 'var(--tokens-text-secondary)' }}>
                            · {ai.flags.length}
                        </span>
                    </h3>
                    <div className="flags">
                        {ai.flags.map((flag, flagIndex) => (
                            <article className="flag" key={flagIndex}>
                                <WarnIcon size={24} color="rgb(225,29,72)" strokeWidth={12} />
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
                                    <div className="flag-t">{flag.title}</div>
                                    {flag.reason && <div className="flag-r">{flag.reason}</div>}
                                    {flag.when && <div className="flag-w">{flag.when}</div>}
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            )}
            {ai.unavailable && (
                <div className="notice">
                    <InfoIcon color="rgb(87,88,111)" />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <span style={{ fontWeight: 600 }}>{t('ai.unavailableTitle')}</span>
                        {/* "everything below comes straight from the documents and is complete" is not true of a
                            Complete report without a read service history (still being checked, or refused) */}
                        {ai.basis !== 'inspection' && (
                            <span style={{ fontSize: 14, color: 'var(--tokens-text-secondary)' }}>
                                {t('ai.unavailableText')}
                            </span>
                        )}
                    </div>
                </div>
            )}
            {ai.ok && (
                <p className="disclaimer">
                    {ai.basis === 'inspection' ? t('ai.disclaimerInspection') : t('ai.disclaimer')}
                </p>
            )}
        </section>
    );
};
